import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { DomainsApiService } from '../services/DomainsApiService';
import type { Domain } from '../types/Domain';

const QUERY_KEY = 'domains';

export function useGetDomains() {
    return useQuery<Domain[]>({
        queryKey: [QUERY_KEY],
        queryFn: () => DomainsApiService.list(),
        staleTime: Infinity,
        gcTime: Infinity,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });
}

export function useCreateDomain() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (name: string) => DomainsApiService.create(name),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
        },
    });
}

export function useDiscoverDomains() {
    return useQuery<Domain[]>({
        queryKey: [QUERY_KEY, 'discover'],
        queryFn: () => DomainsApiService.discover(),
    });
}

export function useJoinDomain() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (domainId: string) => DomainsApiService.join(domainId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
            queryClient.invalidateQueries({ queryKey: [QUERY_KEY, 'discover'] });
        },
    });
}
